import { createFileRoute } from '@tanstack/react-router'

import { CreateBookingWizard } from '@/widgets/tablet/create-booking-wizard'

export const Route = createFileRoute('/_tablet-layout/branch/$id/create/_wizard')({
    component: CreateBookingWizard,
})
